




import { Component, Vue } from "vue-property-decorator";

@Component
export default class TopProductBadge extends Vue {
  get customVuexStyles() {
    return {
      "--font-main": this.$store.state.globalCss.font.fontName,
      "--top-product-badge-color": this.$store.state.globalCss.colors
        .topProductBadge.color,
      "--top-product-badge-bg-color": this.$store.state.globalCss.colors
        .topProductBadge.backgroundColor
    };
  }
}
